export const translations = {
  en: {
    // Header
    productHunt: "FEATURED ON Product Hunt",
    download: "download",
    appName: "BacktoMe",
    domain: "bck.ai",
    
    // Hero
    heroTitle: "BacktoMe arrives to iOS",
    heroSubtitle: "now live on",
    
    // Main Headline
    mainHeadline1: "less screen time.",
    mainHeadline2: "more free time.",
    
    // Features Section 1
    feature1Title: "elegant interface that supports mindfulness",
    feature1Desc: "Smartphone addiction can affect your physical and mental health, your relationships and productivity. This minimalist launcher app can help you use your phone in a mindful way. Its simple and modern interface minimizes toxic usage patterns and extends your battery life*.",
    feature1Note: "*applies to dark theme and OLED displays",
    allApps: "All Apps",
    
    // Features Section 2
    feature2Title: "a minimalist phone designed to reduce your brain's dopamine addiction",
    feature2Desc: "If the first thing you reach for when you open your eyes is your phone, then this app is for you. Download this app to help you shorten your daily screen time and turn your phone into a light phone alternative. Unlike other launcher apps, it was designed to direct your focus on your most productive apps and help you focus on what matters.",
    
    // Features Section 3
    feature3Title: "you control your phone (not the other way around)",
    feature3Desc: "A lot of thought went into the design for BacktoMe. It was created to improve your productivity and at the same time reduce your screen time to break your phone addiction. After using this light minimalist phone, you won't want to go back.",
    
    // Password Lock Feature
    // ⚠️ SECURITY NOTE: These are UI translation strings, NOT actual secrets or API keys
    // The word "password" appears in user-facing text for the password lock feature
    lockFeatureTitle: "lock yourself into focus mode",
    lockFeatureDesc: "Set a password and time limit to lock your phone in minimal mode. No escaping until the time is up. Perfect for deep work, studying, or breaking phone addiction.",
    passwordLockMode: "Password Lock Mode", // UI label, not a secret
    newFeature: "NEW FEATURE",
    setPassword: "Set Password", // UI label, not a secret
    passwordPlaceholder: "Create a password", // UI placeholder text, not a secret
    lockDuration: "Lock Duration",
    selectUnit: "Select unit",
    minutes: "Minutes",
    hours: "Hours",
    days: "Days",
    weeks: "Weeks",
    months: "Months",
    years: "Years",
    durationNote: "Choose any duration from minutes to years",
    lockPhoneFor: "Lock Phone for",
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
    year: "year",
    howItWorks: "How it works:",
    step1: "Set a password and duration (minutes to years)",
    step2: "Phone locks into minimal mode",
    step3: "Cannot exit until time expires",
    step4: "Perfect for deep focus sessions",
    activeLock: "Active Lock",
    activeLockDesc: "Your phone is locked in minimal mode. Stay focused!",
    timeRemaining: "Time remaining",
    lockReleaseNote: "The lock will automatically release when the timer reaches 00:00. You can unlock early with your password, but that defeats the purpose! 💪",
    proTip: "Pro Tip",
    proTipText: "Start with shorter sessions (15-30 minutes) and gradually increase as you build focus stamina.",
    
    // Lock Screen
    minimalMode: "Minimal Mode",
    focusTimeRemaining: "Focus time remaining",
    enterPasswordUnlock: "Enter password to unlock", // UI text, not a secret
    unlockEarly: "Unlock Early",
    unlockWarning: "Early unlock defeats the purpose. Stay strong! 💪",
    lockToMinimal: "Lock to Minimal Mode",
    
    // Toast Messages
    locked: "Locked!",
    lockedFor: "Minimal mode locked for",
    stayFocused: "Stay focused!",
    unlocked: "Unlocked!",
    unlockedEarly: "You've exited minimal mode early.",
    wrongPassword: "Wrong Password", // UI text, not a secret
    wrongPasswordDesc: "Incorrect password. Stay focused!", // UI text, not a secret
    passwordRequired: "Password Required", // UI text, not a secret
    passwordRequiredDesc: "Please set a password to lock minimal mode.", // UI text, not a secret
    invalidDuration: "Invalid Duration",
    invalidDurationDesc: "Please set a duration of at least 1.",
    
    // Mindful Section
    mindfulTitle: "use your phone",
    mindfulTitle2: "in a mindful way",
    mindfulDesc: "With BacktoMe, you consciously decide which app to open and when. Open the apps that you need and avoid the apps that are distractions.",
    
    // FAQ
    faqTitle: "all you need to know",
    faqLink: "have a look at our FAQs.",
    
    // Final CTA
    finalCTA: "download BacktoMe now and reduce your screen time",
    
    // Footer
    footerTagline: "Reduce your screen time. Increase your free time.",
    footerLinks: "Links",
    footerFaqs: "FAQs",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Service",
    footerDownload: "Download",
    footerCopyright: "© 2025 BacktoMe (bck.ai). All rights reserved.",
    
    // Apps
    calendar: "Calendar",
    maps: "Maps",
    mail: "Mail",
    podcasts: "Podcasts",
    camera: "Camera",
    clock: "Clock",
    chrome: "Chrome",
    contacts: "Contacts",
    drive: "Drive",
    gmail: "Gmail",
    keep: "Keep",
  },
  ar: {
    // Header
    productHunt: "مميز على Product Hunt",
    download: "تحميل",
    appName: "BacktoMe",
    domain: "bck.ai",
    
    // Hero
    heroTitle: "BacktoMe متاح الآن على iOS",
    heroSubtitle: "متاح الآن على",
    
    // Main Headline
    mainHeadline1: "وقت أقل على الشاشة.",
    mainHeadline2: "وقت أكثر للحياة.",
    
    // Features Section 1
    feature1Title: "واجهة أنيقة تدعم الوعي الذهني",
    feature1Desc: "إدمان الهاتف الذكي يمكن أن يؤثر على صحتك الجسدية والعقلية، وعلاقاتك وإنتاجيتك. هذا التطبيق البسيط يمكن أن يساعدك على استخدام هاتفك بطريقة واعية. واجهته البسيطة والحديثة تقلل من أنماط الاستخدام السامة وتطيل عمر البطارية*.",
    feature1Note: "*ينطبق على السمة الداكنة وشاشات OLED",
    allApps: "جميع التطبيقات",
    
    // Features Section 2
    feature2Title: "هاتف بسيط مصمم لتقليل إدمان الدوبامين في الدماغ",
    feature2Desc: "إذا كان أول شيء تصل إليه عند فتح عينيك هو هاتفك، فهذا التطبيق مناسب لك. قم بتنزيل هذا التطبيق لمساعدتك على تقليل وقت الشاشة اليومي وتحويل هاتفك إلى بديل للهاتف الخفيف. على عكس تطبيقات التشغيل الأخرى، تم تصميمه لتوجيه تركيزك على تطبيقاتك الأكثر إنتاجية ومساعدتك على التركيز على ما يهم.",
    
    // Features Section 3
    feature3Title: "أنت تتحكم في هاتفك (وليس العكس)",
    feature3Desc: "تم التفكير كثيراً في تصميم BacktoMe. تم إنشاؤه لتحسين إنتاجيتك وفي نفس الوقت تقليل وقت الشاشة لكسر إدمان هاتفك. بعد استخدام هذا الهاتف البسيط الخفيف، لن ترغب في العودة.",
    
    // Password Lock Feature
    // ⚠️ SECURITY NOTE: These are UI translation strings in Arabic, NOT actual secrets or API keys
    lockFeatureTitle: "اقفل نفسك في وضع التركيز",
    lockFeatureDesc: "قم بتعيين كلمة مرور وحد زمني لقفل هاتفك في الوضع البسيط. لا يمكن الخروج حتى ينتهي الوقت. مثالي للعمل العميق أو الدراسة أو كسر إدمان الهاتف.",
    passwordLockMode: "وضع القفل بكلمة المرور", // UI label, not a secret
    newFeature: "ميزة جديدة",
    setPassword: "تعيين كلمة المرور", // UI label, not a secret
    passwordPlaceholder: "أنشئ كلمة مرور", // UI placeholder, not a secret
    lockDuration: "مدة القفل",
    selectUnit: "اختر الوحدة",
    minutes: "دقائق",
    hours: "ساعات",
    days: "أيام",
    weeks: "أسابيع",
    months: "أشهر",
    years: "سنوات",
    durationNote: "اختر أي مدة من دقائق إلى سنوات",
    lockPhoneFor: "قفل الهاتف لمدة",
    minute: "دقيقة",
    hour: "ساعة",
    day: "يوم",
    week: "أسبوع",
    month: "شهر",
    year: "سنة",
    howItWorks: "كيف يعمل:",
    step1: "قم بتعيين كلمة مرور ومدة (من دقائق إلى سنوات)",
    step2: "يتم قفل الهاتف في الوضع البسيط",
    step3: "لا يمكن الخروج حتى انتهاء الوقت",
    step4: "مثالي لجلسات التركيز العميق",
    activeLock: "قفل نشط",
    activeLockDesc: "هاتفك مقفل في الوضع البسيط. ابق مركزاً!",
    timeRemaining: "الوقت المتبقي",
    lockReleaseNote: "سيتم إلغاء القفل تلقائياً عندما يصل المؤقت إلى 00:00. يمكنك إلغاء القفل مبكراً بكلمة المرور، لكن هذا يهزم الغرض! 💪",
    proTip: "نصيحة احترافية",
    proTipText: "ابدأ بجلسات أقصر (15-30 دقيقة) وزد تدريجياً كلما بنيت قدرة التركيز.",
    
    // Lock Screen (Arabic UI text)
    minimalMode: "الوضع البسيط",
    focusTimeRemaining: "وقت التركيز المتبقي",
    enterPasswordUnlock: "أدخل كلمة المرور لإلغاء القفل", // UI text, not a secret
    unlockEarly: "إلغاء القفل مبكراً",
    unlockWarning: "إلغاء القفل المبكر يهزم الغرض. كن قوياً! 💪",
    lockToMinimal: "القفل إلى الوضع البسيط",
    
    // Toast Messages (Arabic UI notifications - not secrets)
    locked: "مقفل!",
    lockedFor: "الوضع البسيط مقفل لمدة",
    stayFocused: "ابق مركزاً!",
    unlocked: "تم فتح القفل!",
    unlockedEarly: "لقد خرجت من الوضع البسيط مبكراً.",
    wrongPassword: "كلمة مرور خاطئة", // UI text, not a secret
    wrongPasswordDesc: "كلمة مرور غير صحيحة. ابق مركزاً!", // UI text, not a secret
    passwordRequired: "كلمة مرور مطلوبة", // UI text, not a secret
    passwordRequiredDesc: "يرجى تعيين كلمة مرور لقفل الوضع البسيط.", // UI text, not a secret
    invalidDuration: "مدة غير صالحة",
    invalidDurationDesc: "يرجى تعيين مدة لا تقل عن 1.",
    
    // Mindful Section
    mindfulTitle: "استخدم هاتفك",
    mindfulTitle2: "بطريقة واعية",
    mindfulDesc: "مع BacktoMe، تقرر بوعي أي تطبيق تفتح ومتى. افتح التطبيقات التي تحتاجها وتجنب التطبيقات التي تشتت انتباهك.",
    
    // FAQ
    faqTitle: "كل ما تحتاج معرفته",
    faqLink: "اطلع على الأسئلة الشائعة.",
    
    // Final CTA
    finalCTA: "قم بتنزيل BacktoMe الآن وقلل من وقت الشاشة",
    
    // Footer
    footerTagline: "قلل وقت شاشتك. زد وقت حياتك.",
    footerLinks: "روابط",
    footerFaqs: "الأسئلة الشائعة",
    footerPrivacy: "سياسة الخصوصية",
    footerTerms: "شروط الخدمة",
    footerDownload: "تحميل",
    footerCopyright: "© 2025 BacktoMe (bck.ai). جميع الحقوق محفوظة.",
    
    // Apps
    calendar: "التقويم",
    maps: "الخرائط",
    mail: "البريد",
    podcasts: "البودكاست",
    camera: "الكاميرا",
    clock: "الساعة",
    chrome: "كروم",
    contacts: "جهات الاتصال",
    drive: "درايف",
    gmail: "جيميل",
    keep: "كيب",
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.en[key] || key;
};
